import { Head, Link, useForm } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { DashboardLayout } from '@/layouts/DashboardLayout'
import { industriesPath } from '@/lib/routes'

import { IndustryFormFields, type IndustryFormData } from './_Form'

function IndustriesNew() {
  const form = useForm<IndustryFormData>({
    name_en: '',
    name_es: '',
    emoji: '',
  })

  return (
    <>
      <Head title="New industry" />

      <div className="mx-auto max-w-3xl px-8 py-10">
        <Link
          href={industriesPath()}
          className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to industries
        </Link>

        <PageHeader title="New industry" description="Add a new classification tag." />

        <form
          onSubmit={(event) => {
            event.preventDefault()
            form.transform((data) => ({ industry: data }))
            form.post(industriesPath())
          }}
        >
          <IndustryFormFields
            data={form.data}
            errors={form.errors as Partial<Record<keyof IndustryFormData, string>>}
            setData={form.setData}
          />

          <div className="mt-6 flex justify-end gap-2">
            <Link href={industriesPath()}>
              <Button type="button" variant="ghost">
                Cancel
              </Button>
            </Link>
            <Button type="submit" disabled={form.processing}>
              {form.processing ? 'Saving…' : 'Create industry'}
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

export default Object.assign(IndustriesNew, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
